import React from 'react';

const HomeGardenCondition = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4136_279)">
            <g clipPath="url(#clip1_4136_279)">
                <path
                    d="M5.92862 10.8356C5.90613 10.1056 6.47968 9.49563 7.20966 9.47314C7.46934 9.46514 7.72562 9.53381 7.94651 9.67058L9.77659 10.7854C9.9938 10.9181 10.2447 10.9853 10.4992 10.979L12.6414 10.9286C13.3714 10.9061 13.9814 11.4796 14.0039 12.2096C14.0119 12.4693 13.9432 12.7256 13.8065 12.9465L12.6917 14.7766C12.559 14.9938 12.4918 15.2447 12.4981 15.4991L12.5485 17.6414C12.571 18.3714 11.9974 18.9814 11.2674 19.0039C11.0077 19.0119 10.7515 18.9432 10.5306 18.8064L8.7005 17.6917C8.48329 17.5589 8.2324 17.4917 7.97793 17.4981L5.83565 17.5484C5.10566 17.5709 4.49566 16.9974 4.47318 16.2674C4.46518 16.0077 4.53385 15.7514 4.67061 15.5305L5.78538 13.7005C5.91811 13.4833 5.98534 13.2324 5.979 12.9779L5.92862 10.8356Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.2242 3.17153C15.2114 2.75825 15.5362 2.4129 15.9494 2.40018C16.0965 2.39565 16.2415 2.43453 16.3666 2.51196L17.4027 3.14308C17.5257 3.21823 17.6677 3.25629 17.8118 3.2527L19.0246 3.22417C19.4379 3.21145 19.7832 3.53616 19.796 3.94944C19.8005 4.09645 19.7616 4.24154 19.6842 4.36659L19.0531 5.40269C18.9779 5.52566 18.9399 5.6677 18.9435 5.81177L18.972 7.02462C18.9847 7.4379 18.66 7.78325 18.2467 7.79597C18.0997 7.8005 17.9546 7.76162 17.8296 7.6842L16.7935 7.05307C16.6705 6.97792 16.5284 6.93986 16.3844 6.94345L15.1715 6.97198C14.7582 6.98471 14.4129 6.65999 14.4002 6.24671C14.3957 6.0997 14.4345 5.95461 14.512 5.82956L15.1431 4.79346C15.2182 4.67049 15.2563 4.52845 15.2527 4.38438L15.2242 3.17153Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 20.9999C4.02761 20.9999 4.05 21.0223 4.05 21.0499"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0502 18C19.0502 18.0276 19.0278 18.0499 19.0002 18.0499C18.9726 18.0499 18.9502 18.0276 18.9502 18C18.9502 17.9723 18.9726 17.95 19.0002 17.95"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17.95C19.0276 17.95 19.05 17.9723 19.05 18"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.1 3.05C7.1 3.07761 7.07761 3.1 7.05 3.1C7.02239 3.1 7 3.07761 7 3.05C7 3.02239 7.02239 3 7.05 3"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4136_279">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4136_279">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default HomeGardenCondition;
